import script from "./VueMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./VueMenu.vue?vue&type=script&setup=true&lang=js"

import "./VueMenu.vue?vue&type=style&index=0&id=f52af40e&lang=scss&scoped=true"
import "./VueMenu.vue?vue&type=style&index=1&id=f52af40e&lang=scss"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f52af40e"]])

export default __exports__